import React from 'react';
import { MapPin } from 'lucide-react';

const Announcement = () => {
  return (
    <div className="relative announce-shimmer border-y border-[#E5DED0]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-3 flex items-center justify-center gap-3 text-[12px] md:text-sm text-[#4a463f]">
        <MapPin size={14} className="text-[#7B1E24]" />
        <span className="tracking-wide">
          <span className="font-semibold text-[#1a1a1a]">Now open</span> at our new home —
          Pioneer Lot, 35C Benoi Road, Singapore
        </span>
      </div>
    </div>
  );
};

export default Announcement;
